var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var defaultOptions = {
    baseUrl: 'https://cloud.liquid-state.com/',
    baseS3Url: 'https://s3.ap-southeast-2.amazonaws.com/liquidstate-prod-apsoutheast2/',
    identity: {},
};
var pathMap = {
    appPublicConfig: 'c/{{companyToken}}/apps/{{appToken}}/app.json',
    registration: 'api/appusers/v1/{{appToken}}/register/',
    getProfile: 'api/appusers/v1/{{appToken}}/profile/',
    setProfile: 'api/appusers/v1/{{appToken}}/profile/set/',
    setDevice: 'api/appusers/v1/{{appToken}}/set_device/',
    appConfig: 'c/{{companyToken}}/apps/{{appToken}}/app_users/{{appUserId}}/app_config.json',
    messageHistory: 'c/{{companyToken}}/apps/{{appToken}}/app_users/{{appUserId}}/messaging/list.json',
    viewableIssues: 'c/{{companyToken}}/apps/{{appToken}}/app_users/{{appUserId}}/app_config.json',
};
export var UbiquityError = function (message, response) { return ({
    message: "Ubiquity API Error: " + message,
    response: response,
}); };
var Ubiquity = /** @class */ (function () {
    function Ubiquity(companyToken, appToken, options) {
        var _this = this;
        this.companyToken = companyToken;
        this.appToken = appToken;
        this.register = function (username, password) {
            var url = _this.getUrl('registration');
            var body = new FormData();
            body.append('json_data', JSON.stringify({ username: username, password: password }));
            return fetch(url, {
                method: 'POST',
                body: body,
            });
        };
        this.getProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var url, resp, _a, _b, _c, _d, _e, content;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        url = this.getUrl('getProfile');
                        _a = fetch;
                        _b = [url];
                        _c = {};
                        _d = {};
                        _e = "Bearer ";
                        return [4 /*yield*/, this.jwt()];
                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = (_d.Authorization = _e + (_f.sent()),
                                _d),
                                _c)]))];
                    case 2:
                        resp = _f.sent();
                        if (!resp.ok) {
                            throw UbiquityError('Unable to get profile for user', resp);
                        }
                        return [4 /*yield*/, resp.json()];
                    case 3:
                        content = _f.sent();
                        return [2 /*return*/, content.data];
                }
            });
        }); };
        this.setProfile = function (profile, clearExistingProfile) {
            if (clearExistingProfile === void 0) { clearExistingProfile = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var url, body, resp, _a, _b, _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            url = this.getUrl('setProfile');
                            body = new FormData();
                            if (clearExistingProfile) {
                                profile['_clear_profile'] = true;
                            }
                            body.append('json_data', JSON.stringify(profile));
                            _a = fetch;
                            _b = [url];
                            _c = {
                                method: 'POST'
                            };
                            _d = {};
                            _e = "Bearer ";
                            return [4 /*yield*/, this.jwt()];
                        case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = (_d.Authorization = _e + (_f.sent()),
                                    _d),
                                    _c.body = body,
                                    _c)]))];
                        case 2:
                            resp = _f.sent();
                            if (!resp.ok) {
                                throw UbiquityError('Unable to update profile data', resp);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.setDevice = function (installationId) { return __awaiter(_this, void 0, void 0, function () {
            var url, body, resp, _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        url = this.getUrl('setDevice');
                        body = new FormData();
                        body.append('action', 'add');
                        body.append('installation_id', installationId);
                        _a = fetch;
                        _b = [url];
                        _c = {
                            method: 'POST'
                        };
                        _d = {};
                        _e = "Bearer ";
                        return [4 /*yield*/, this.jwt()];
                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = (_d.Authorization = _e + (_f.sent()),
                                _d),
                                _c.body = body,
                                _c)]))];
                    case 2:
                        resp = _f.sent();
                        if (!resp.ok) {
                            throw UbiquityError('Unable to update device', resp);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.appPublicConfiguration = function () { return __awaiter(_this, void 0, void 0, function () {
            var url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getUrl('appPublicConfig', true);
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw UbiquityError('Unable to retrieve app public config', resp);
                        }
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.appConfiguration = function () { return __awaiter(_this, void 0, void 0, function () {
            var sub, _a, url, resp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.sub;
                        return [4 /*yield*/, this.jwt()];
                    case 1:
                        sub = _a.apply(this, [_b.sent()]);
                        url = this.getUrl('appConfig', true).replace('{{appUserId}}', sub);
                        return [4 /*yield*/, fetch(url)];
                    case 2:
                        resp = _b.sent();
                        if (!resp.ok) {
                            throw UbiquityError('Unable to retrieve app config for the current user ', resp);
                        }
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.appContent = function (useOldStyleDocumentMap) {
            if (useOldStyleDocumentMap === void 0) { useOldStyleDocumentMap = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var jwt, sub, _a, url, resp, data;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.jwt()];
                        case 1:
                            jwt = _b.sent();
                            if (!jwt) {
                                return [2 /*return*/, this.publicAppContent()];
                            }
                            _a = this.sub;
                            return [4 /*yield*/, this.jwt()];
                        case 2:
                            sub = _a.apply(this, [_b.sent()]);
                            url = this.getUrl('viewableIssues', true).replace('{{appUserId}}', sub);
                            return [4 /*yield*/, fetch(url)];
                        case 3:
                            resp = _b.sent();
                            if (!resp.ok) {
                                throw UbiquityError('Unable to retrieve the viewable issues for the current user ', resp);
                            }
                            return [4 /*yield*/, resp.json()];
                        case 4:
                            data = _b.sent();
                            if ('documents' in data && useOldStyleDocumentMap) {
                                return [2 /*return*/, {
                                        categories: data.categories,
                                        iaps: {
                                            ios: data.documents,
                                            android: data.documents,
                                            web: data.documents,
                                        },
                                    }];
                            }
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        this.messageHistory = function () { return __awaiter(_this, void 0, void 0, function () {
            var sub, _a, url, resp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.sub;
                        return [4 /*yield*/, this.jwt()];
                    case 1:
                        sub = _a.apply(this, [_b.sent()]);
                        url = this.getUrl('messageHistory', true).replace('{{appUserId}}', sub);
                        return [4 /*yield*/, fetch(url)];
                    case 2:
                        resp = _b.sent();
                        if (!resp.ok) {
                            if (resp.status === 403) {
                                return [2 /*return*/, { messages: [] }];
                            }
                            else {
                                throw UbiquityError('Unable to retrieve the message history for the current user ', resp);
                            }
                        }
                        return [2 /*return*/, resp.json()];
                }
            });
        }); };
        this.publicAppContent = function () { return __awaiter(_this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.appPublicConfiguration()];
                    case 1:
                        config = _a.sent();
                        return [2 /*return*/, {
                                categories: config.categories,
                                documents: config.iaps.ios,
                            }];
                }
            });
        }); };
        if (!options) {
            this.options = defaultOptions;
        }
        else {
            this.options = __assign(__assign({}, defaultOptions), options);
            if (!this.options.baseUrl) {
                this.options.baseUrl = defaultOptions.baseUrl;
            }
            if (!this.options.baseS3Url) {
                this.options.baseS3Url = defaultOptions.baseS3Url;
            }
        }
    }
    Ubiquity.prototype.getUrl = function (endpoint, useS3) {
        if (useS3 === void 0) { useS3 = false; }
        var result;
        if (this.options.als) {
            result = this.options.als.getUrl('ubiquity', endpoint);
        }
        else if (endpoint in pathMap) {
            var baseUrl = useS3 ? this.options.baseS3Url : this.options.baseUrl;
            result = "" + baseUrl + pathMap[endpoint];
        }
        if (result === undefined) {
            throw Error("Unable to find url for ubiquity client, endpoint: " + name);
        }
        result = result
            .replace('{{companyToken}}', this.companyToken)
            .replace('{{appToken}}', this.appToken);
        return result;
    };
    Ubiquity.prototype.jwt = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.options.identity) {
                            return [2 /*return*/, undefined];
                        }
                        if (!this.options.identity.jwt) return [3 /*break*/, 1];
                        return [2 /*return*/, this.options.identity.jwt];
                    case 1:
                        if (!this.options.identity.identityProvider) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.options.identity.identityProvider.getIdentity()];
                    case 2:
                        id = _a.sent();
                        return [2 /*return*/, id.isAuthenticated ? id.credentials.jwt : undefined];
                    case 3: return [2 /*return*/, undefined];
                }
            });
        });
    };
    Ubiquity.prototype.sub = function (jwt) {
        // Get the body of the JWT.
        var payload = jwt.split('.')[1];
        // Which is base64 encoded.
        var parsed = JSON.parse(atob(payload));
        return parsed.sub;
    };
    return Ubiquity;
}());
export default Ubiquity;
//# sourceMappingURL=client.js.map